<template>
  <div>
    <b-form ref="form">
      <!-- Personal Information Row -->
      <div class="row mb-3">
        <!-- <b-form-group class="col-3">
          <template #label>
            <label>Họ:</label>
          </template>
          <b-form-input
            size="sm"
            type="text"
            v-model="customerForm.lastName"
            placeholder="Nhập họ"
          ></b-form-input>
        </b-form-group> -->

        <b-form-group class="col-3">
          <template #label>
            <label>Tên khách hàng/ncc/đơn vị:</label>
            <span class="text-danger">*</span>
          </template>
          <b-form-input
            size="sm"
            type="text"
            v-model="customerForm.fullName"
            :state="validateState('fullName')"
            placeholder="Nhập tên"
          ></b-form-input>
          <b-form-invalid-feedback>
            Vui lòng nhập tên khách hàng
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="col-3">
          <template #label>
            <label>Điện thoại:</label>
            <span class="text-danger" v-if="isPhoneRequired">*</span>
          </template>
          <b-form-input
            size="sm"
            type="text"
            v-model="customerForm.phoneNo"
            :state="validateState('phoneNo')"
            placeholder="Nhập số điện thoại"
            :disabled="isEditMode"
          ></b-form-input>
          <b-form-invalid-feedback v-if="v$.phoneNo.$error">
            <span v-if="!v$.phoneNo.required">Vui lòng nhập số điện thoại</span>
            <span v-else-if="!v$.phoneNo.isValidPhoneNumber"
              >Vui lòng nhập số điện thoại hợp lệ</span
            >
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="col-3">
          <template #label>
            <label>Email:</label>
          </template>
          <b-form-input
            size="sm"
            type="text"
            inputmode="email"
            autocomplete="email"
            v-model="customerForm.email"
            :state="validateState('email')"
            placeholder="vd: hoadon@vender.vn"
          ></b-form-input>
          <b-form-invalid-feedback v-if="v$.email.$error">
            Email không đúng định dạng
          </b-form-invalid-feedback>
        </b-form-group>
      </div>

      <!-- Secondary Information Row -->
      <div class="row mb-3">
        <b-form-group class="col-3">
          <template #label>
            <label>Ngày sinh:</label>
          </template>
          <date-picker
            placeholder="Chọn ngày sinh"
            class="form-control form-control-sm"
            :config="datePickerConfig"
            v-model="customerForm.dateOfBirth"
          ></date-picker>
        </b-form-group>

        <div class="col-3">
          <div class="gender-appellation">
            <b-form-group class="gender">
              <template #label>
                <label>Giới tính:</label>
              </template>
              <b-form-select
                size="sm"
                v-model="customerForm.gender"
                :options="genderOptions"
                :state="validateState('gender')"
                class="select-style"
                value-field="id"
                text-field="name"
              ></b-form-select>
              <b-form-invalid-feedback v-if="v$.gender?.$error">
                Vui lòng chọn giới tính
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group class="appellation">
              <template #label>
                <label>Danh xưng:</label>
              </template>
              <b-form-select
                size="sm"
                v-model="customerForm.appellation"
                :options="appellationOptions"
                :state="validateState('appellation')"
                class="select-style"
                value-field="id"
                text-field="name"
              ></b-form-select>
              <b-form-invalid-feedback v-if="v$.appellation?.$error">
                Vui lòng chọn danh xưng
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>

        <b-form-group class="col-3">
          <template #label>
            <label>Nhóm kh/ncc:</label>
          </template>
          <b-form-select
            size="sm"
            v-model="customerForm.type"
            :options="customerTypes"
            class="select-style"
            value-field="id"
            text-field="name"
          >
            <template v-slot:first>
              <b-form-select-option :value="null"
                >-- Loại --</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group class="col-3">
          <template #label>
            <label>Nhân viên phụ trách:</label>
          </template>
          <employee-selector
            v-model="customerForm.inChargeEmployeeName"
            @select="onEmployeeSelected"
          />
        </b-form-group>
      </div>

      <!-- Location Row -->
      <div class="row mb-3">
        <location-selector v-model="locationModel" class="col-9" />
        <b-form-group class="col-3">
          <template #label>
            <label for="input-credit-limit">Hạn mức công nợ:</label>
          </template>
          <b-form-input
            tabindex="4"
            v-model="customerForm.creditLimit"
            :state="validateState('creditLimit')"
            type="number"
            step="0.01"
            placeholder="Nhập hạn mức công nợ"
            aria-describedby="input-credit-limit-feedback"
            size="sm"
          />
          <b-form-invalid-feedback v-if="v$.creditLimit.isValidDecimal"
            >Vui lòng nhập số tiền hợp lệ!</b-form-invalid-feedback
          >
          <small class="form-text text-muted">
            <i class="fa fa-exclamation-circle text-warning mr-1 fa-sm"></i>
            Để trống nếu không giới hạn
          </small>
        </b-form-group>
      </div>
      <div class="row mb-3">
        <!-- <b-form-group class="col-3">
          <template #label>
            <label>Tên công ty(đơn vị):</label>
          </template>
          <b-input
            size="sm"
            v-model="customerForm.companyName"
            placeholder="Nhập tên công ty/ đơn vị"
          ></b-input>
        </b-form-group> -->
      </div>

      <!-- Supplier Information Row (Provider → Customer merge) -->
      <div class="row mb-3">
        <b-form-group class="col-3">
          <template #label>
            <label>Mã số thuế:</label>
            <span class="text-danger" v-if="isTaxCodeRequired">*</span>
          </template>
          <b-input
            size="sm"
            v-model="customerForm.taxCode"
            :state="validateState('taxCode')"
            placeholder="Nhập mã số thuế"
          ></b-input>
          <b-form-invalid-feedback v-if="v$.taxCode?.$error">
            Vui lòng nhập mã số thuế
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group class="col-3">
          <template #label>
            <label>Mã khách hàng/nhà cung cấp:</label>
            <span class="text-danger">*</span>
          </template>
          <b-form-input
            size="sm"
            v-model="customerForm.code"
            :state="validateState('code')"
            placeholder="Nhập mã khách hàng/nhà cung cấp"
            :disabled="isViewOnly"
          />
          <b-form-invalid-feedback v-if="v$.code.$error">
            Vui lòng nhập mã khách hàng/nhà cung cấp
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="col-3">
          <template #label>
            <label>KH/NCC chính:</label>
          </template>
          <p v-if="customerForm.parentName" class="mt-2 mb-0 font-weight-500">
            {{ customerForm.parentName }}
          </p>
          <p v-else class="mt-2 mb-0 text-muted">—</p>
        </b-form-group>

        <!-- <b-form-group class="col-3">
          <template #label>
            <label>Nhóm nhà cung cấp:</label>
          </template>
          <b-form-select
            size="sm"
            v-model="customerForm.supplierGroupId"
            :disabled="isViewOnly || isLoadingSupplierGroups"
            class="select-style"
          >
            <template #first>
              <b-form-select-option :value="null">-- Nhóm --</b-form-select-option>
            </template>
            <b-form-select-option
              v-for="g in supplierGroups"
              :key="g.id"
              :value="g.id"
            >
              {{ g.name }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group> -->

        <b-form-group class="col-3">
          <template #label>
            <label>Cho phép nợ (ngày):</label>
          </template>
          <b-form-input
            size="sm"
            type="number"
            min="0"
            v-model="customerForm.paymentTermsDays"
            placeholder="Nhập số ngày cho phép nợ"
            :disabled="isViewOnly"
          />
        </b-form-group>

        <b-form-group class="col-3">
          <template #label>
            <label>CMND/CCCD:</label>
          </template>
          <b-form-input
            size="sm"
            v-model="customerForm.identifyNo"
            placeholder="Nhập CMND/CCCD"
            :disabled="isViewOnly"
          />
        </b-form-group>
      </div>

      <div class="row mb-3">
        <b-form-group class="col-3">
          <template #label>
            <label>Đại diện:</label>
          </template>
          <b-form-input
            size="sm"
            v-model="customerForm.representativeName"
            placeholder="Nhập tên đại diện"
            :disabled="isViewOnly"
          />
        </b-form-group>
        <b-form-group class="col-3">
          <template #label>
            <label>Chức vụ:</label>
          </template>
          <b-form-input
            size="sm"
            v-model="customerForm.representativeJobTitle"
            placeholder="Nhập chức vụ đại diện"
            :disabled="isViewOnly"
          />
        </b-form-group>
      </div>

      <div class="row mb-3">
        <b-form-group class="col-6">
          <template #label>
            <label>Địa chỉ giao hàng 1:</label>
          </template>
          <b-form-input
            size="sm"
            v-model="customerForm.shippingAddress1"
            placeholder="Nhập địa chỉ giao hàng chính"
            :disabled="isViewOnly"
          />
        </b-form-group>
        <b-form-group class="col-6">
          <template #label>
            <label>Địa chỉ giao hàng 2:</label>
          </template>
          <b-form-input
            size="sm"
            v-model="customerForm.shippingAddress2"
            placeholder="Nhập địa chỉ giao hàng phụ"
            :disabled="isViewOnly"
          />
        </b-form-group>
      </div>

      <!-- Address and Notes Row -->
      <div class="row mb-3">
        <b-form-group class="col-6">
          <template #label>
            <label>Địa chỉ:</label>
          </template>
          <b-form-textarea
            size="sm"
            v-model="customerForm.address"
            placeholder="Nhập địa chỉ"
            :rows="6"
            :max-rows="8"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group class="col-6">
          <template #label>
            <label>Ghi chú:</label>
          </template>
          <b-form-textarea
            size="sm"
            v-model="customerForm.note"
            placeholder="Thêm ghi chú"
            :rows="6"
            :max-rows="8"
          ></b-form-textarea>
        </b-form-group>
      </div>

      <!-- Sub-supplier list — chỉ hiển thị ở edit mode -->
      <div class="row mb-3" v-if="isEditMode && customerId">
        <div class="col-12">
          <SubSupplierList
            :parent-id="Number(customerId)"
            :is-view-only="isViewOnly"
          />
        </div>
      </div>

      <template>
        <div>
          <b-form @submit.prevent="submitForm">
            <!-- Form content remains the same -->

            <!-- Action Buttons -->
            <div class="row">
              <b-col cols="12">
                <b-button
                  style="width: 70px"
                  variant="primary"
                  size="sm"
                  type="submit"
                >
                  {{ submitButtonText }}
                </b-button>
                <router-link :to="'/customers'">
                  <b-button
                    style="width: 70px"
                    variant="outline-secondary"
                    size="sm"
                    class="ml-2"
                  >
                    Hủy
                  </b-button>
                </router-link>
              </b-col>
            </div>
          </b-form>
        </div>
      </template>
    </b-form>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, onMounted, watch, computed } from 'vue';
import datePicker from 'vue-bootstrap-datetimepicker';
import EmployeeSelector from './EmployeeSelector.vue';
import LocationSelector from './LocationSelector.vue';
import SubSupplierList from './SubSupplierList.vue';
import { useVuelidate } from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import { SupplierGroupService } from '@/view/pages/supplier-group/service/supplier-group.service.js';
import { CustomerTypeService } from '@/view/pages/customer-type/service/customer-type.service';
import { CUSTOMER_TYPE } from '@/utils/enum';


/** Email tùy chọn: để trống = hợp lệ; có nhập thì chuẩn hóa trim rồi kiểm tra RFC-style (thư viện). */
function optionalEmail(value) {
  const v = value == null ? '' : String(value).trim();
  return email.$validator(v);
}
import ApiService from '@/core/services/api.service';
import moment from 'moment';

export default defineComponent({
  name: 'CustomerForm',

  components: {
    datePicker,
    EmployeeSelector,
    LocationSelector,
    SubSupplierList,
  },

  props: {
    customerId: {
      type: [String, Number],
      default: null,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    isViewOnly: {
      type: Boolean,
      default: false,
    },
    submitButtonText: {
      type: String,
      default: 'Lưu',
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['submit-success', 'submit-error', 'cancel'],

  setup(props, { emit }) {
    const customerForm = reactive({
      fullName: '',
      phoneNo: '',
      email: '',
      lastName: '',
      address: '',
      dateOfBirth: null,
      city: null,
      district: null,
      ward: null,
      firstName: '',
      gender: null,
      type: null,
      appellation: null,
      inChargeEmployeeName: '',
      inChargeEmployeeId: null,
      note: '',
      totalPoint: 0,
      creditLimit: 0,
      taxCode: '',
      companyName: '',
      code: '',
      shippingAddress1: '',
      shippingAddress2: '',
      supplierGroupId: null,
      paymentTermsDays: null,
      identifyNo: '',
      representativeName: '',
      representativeJobTitle: '',
      parentId: null,
      parentName: '',
    });

    const isSubmitting = ref(false);
    const isLoading = ref(false);
    const isLoadingSupplierGroups = ref(false);
    const supplierGroups = ref([]);
    const customerTypes = ref([]);

    const isPhoneRequired = computed(() => {
      // Công ty: SĐT không bắt buộc
      return customerForm.type !== CUSTOMER_TYPE.COMPANY;
    });

    const isTaxCodeRequired = computed(() => {
      // HKD hoặc Công ty: MST bắt buộc
      return (
        customerForm.type === CUSTOMER_TYPE.BUSINESS_HOUSEHOLD ||
        customerForm.type === CUSTOMER_TYPE.COMPANY
      );
    });

    const rules = computed(() => ({
      fullName: { required },
      code: { required },
      phoneNo: isPhoneRequired.value
        ? {
            required,
            isValidPhoneNumber: (value) => /^[0-9]{10,11}$/.test(value),
          }
        : {
            isValidPhoneNumber: (value) =>
              !value || /^[0-9]{10,11}$/.test(value),
          },
      email: {
        email: helpers.withMessage('Email không đúng định dạng', optionalEmail),
      },
      gender: {},
      appellation: {},
      taxCode: isTaxCodeRequired.value ? { required } : {},
      creditLimit: {
        isValidDecimal: (value) => {
          if (value === null || value === undefined || value === '')
            return true;
          const num = parseFloat(value);
          return !isNaN(num) && num >= 0;
        },
      },
    }));

    const v$ = useVuelidate(rules, customerForm);

    const validateState = (name) => {
      const { $dirty, $error } = v$.value[name] || {};
      return $dirty ? !$error : null;
    };


    const genderOptions = [
      { id: 1, name: 'Nam' },
      { id: 0, name: 'Nữ' },
    ];

    const appellationOptions = [
      { id: 1, name: 'Anh' },
      { id: 2, name: 'Chị' },
      { id: 3, name: 'Cô' },
      { id: 4, name: 'Chú' },
      { id: 5, name: 'Bác' },
    ];

    const datePickerConfig = {
      format: 'DD/MM/YYYY',
      useCurrent: false,
      showClear: true,
      showClose: true,
      locale: 'vi',
      sideBySide: true,
    };

    const locationModel = ref({
      city: customerForm.city,
      district: customerForm.district,
      ward: customerForm.ward,
    });

    const preventCircularUpdates = ref(false);

    function syncLocationModelToForm(newValue) {
      if (preventCircularUpdates.value) return;

      preventCircularUpdates.value = true;
      customerForm.city = newValue.city;
      customerForm.district = newValue.district;
      customerForm.ward = newValue.ward;

      Promise.resolve().then(() => {
        preventCircularUpdates.value = false;
      });
    }

    function syncFormToLocationModel([newCity, newDistrict, newWard]) {
      if (preventCircularUpdates.value) return;

      const locationChanged =
        newCity !== locationModel.value.city ||
        newDistrict !== locationModel.value.district ||
        newWard !== locationModel.value.ward;

      if (locationChanged) {
        preventCircularUpdates.value = true;
        locationModel.value = {
          city: newCity,
          district: newDistrict,
          ward: newWard,
        };

        Promise.resolve().then(() => {
          preventCircularUpdates.value = false;
        });
      }
    }

    watch(locationModel, syncLocationModelToForm, { deep: true });

    watch(
      () => [customerForm.city, customerForm.district, customerForm.ward],
      syncFormToLocationModel,
    );

    const fetchCustomerData = async (id) => {
      if (!id) return;

      try {
        isLoading.value = true;
        const { data } = await ApiService.get(`/v1/customers/${id}`);

        if (!data || !data.data) return;

        const customerData = data.data;
        updateCustomerBasicInfo(customerData);
        updateCustomerLocationInfo(customerData);
      } catch (error) {
        console.error('Error fetching customer data:', error);
      } finally {
        isLoading.value = false;
      }
    };

    function updateCustomerBasicInfo(customerData) {
      const nonLocationFields = Object.keys(customerForm).filter(
        (key) =>
          key in customerData && !['city', 'district', 'ward'].includes(key),
      );

      nonLocationFields.forEach((key) => {
        if (key === 'dateOfBirth' && customerData[key]) {
          customerForm[key] = moment(customerData[key]).format('DD/MM/YYYY');
        } else {
          customerForm[key] = customerData[key];
        }
      });
      customerForm.parentId = customerData.parentId ?? customerData.parent?.id ?? null;
      customerForm.parentName = customerData.parent?.fullName ?? customerData.parentName ?? '';
    }

    function updateCustomerLocationInfo(customerData) {
      const locationData = {
        city: customerData.city || null,
        district: customerData.district || null,
        ward: customerData.ward || null,
      };

      locationModel.value = locationData;

      customerForm.city = locationData.city;
      customerForm.district = locationData.district;
      customerForm.ward = locationData.ward;
    }

    watch(
      () => props.initialData,
      (newData) => {
        if (newData && Object.keys(newData).length > 0) {
          Object.keys(customerForm).forEach((key) => {
            if (key in newData) {
              customerForm[key] = newData[key];
            }
          });
        }
      },
      { immediate: true },
    );

    const loadSupplierGroups = async () => {
      try {
        isLoadingSupplierGroups.value = true;
        const res = await SupplierGroupService.getAllNoPagination({ status: 1 });
        const data = res?.data?.data?.supplierGroups || res?.data?.data || [];
        supplierGroups.value = Array.isArray(data) ? data : [];
      } catch (e) {
        supplierGroups.value = [];
      } finally {
        isLoadingSupplierGroups.value = false;
      }
    };

    const loadCustomerTypes = async () => {
      try {
        const params = props.isEditMode ? {} : { isActive: true };
        const res = await CustomerTypeService.selectAll(params);
        customerTypes.value = res?.data?.data || [];
      } catch (e) {
        customerTypes.value = [];
      }
    };

    onMounted(() => {
      loadSupplierGroups();
      loadCustomerTypes();
      if (props.isEditMode && props.customerId) {
        fetchCustomerData(props.customerId);
      }
    });

    const saveCustomer = async () => {
      isSubmitting.value = true;

      const isValid = await v$.value.$validate();
      if (!isValid) {
        isSubmitting.value = false;
        return false;
      }

      try {
        const payload = { ...customerForm };
        if (typeof payload.email === 'string') {
          const t = payload.email.trim();
          payload.email = t || null;
        }
        if (typeof payload.code === 'string') payload.code = payload.code.trim();
        if (typeof payload.shippingAddress1 === 'string')
          payload.shippingAddress1 = payload.shippingAddress1.trim();
        if (typeof payload.shippingAddress2 === 'string')
          payload.shippingAddress2 = payload.shippingAddress2.trim();
        if (typeof payload.identifyNo === 'string')
          payload.identifyNo = payload.identifyNo.trim();
        payload.supplierGroupId =
          payload.supplierGroupId === '' ? null : payload.supplierGroupId;
        payload.parentId = payload.parentId === '' ? null : payload.parentId;
        payload.paymentTermsDays =
          payload.paymentTermsDays === '' ? null : Number(payload.paymentTermsDays);
        emit('submit-success', payload);
        return true;
      } catch (error) {
        emit('submit-error', error);
        return false;
      } finally {
        isSubmitting.value = false;
      }
    };

    const onEmployeeSelected = (employee) => {
      customerForm.inChargeEmployeeId = employee.id;
      customerForm.inChargeEmployeeName = employee.name;
    };

    const onCancel = () => {
      emit('cancel');
    };

    const submitForm = async (event) => {
      event.preventDefault();
      if (props.isViewOnly) return;

      return await saveCustomer();
    };

    return {
      customerForm,
      v$,
      validateState,
      datePickerConfig,
      locationModel,
      isSubmitting,
      isLoading,
      customerTypes,
      genderOptions,
      appellationOptions,
      supplierGroups,
      isLoadingSupplierGroups,
      isPhoneRequired,
      isTaxCodeRequired,
      onEmployeeSelected,
      onCancel,
      submitForm,
      submitButtonText: props.submitButtonText,
    };
  },
});
</script>

<style scoped>
.gender-appellation {
  display: flex;
  gap: 4px;
}

.select-style {
  border-radius: 0.28rem;
  box-shadow: none;
  border: 1px solid #ced4da;
}

.form-group label {
  font-weight: 500;
}
</style>
